module.exports = __webpack_public_path__ + "static/img/icon_zj_01.ee4415cd.png";